import type { TypeFormFieldElement } from '../../../types/form';

import { merge } from '../../../helper';

// ----------------------------------------------------------------------------

function getFieldNames(form: HTMLFormElement, config: Record<string, any> = {}): string[] {
    // Default Config
    const defConfig: Record<string, any> = {
        exclude: ['button', 'file', 'submit', 'reset'],
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    const list: string[] = [];
    //
    const elements = Array.from(form.elements) as TypeFormFieldElement[];

    //
    for (const elField of elements) {
        //
        if (!elField.name || elField.disabled) {
            continue;
        }

        // --------------------------------------------------------------------

        // If using exclude
        if (config.exclude?.includes(elField.type)) {
            continue;
        }

        // --------------------------------------------------------------------

        //
        list.push(elField.name);
    }

    return list;
}

// ----------------------------------------------------------------------------

export default getFieldNames;
